import { PeriodSelection } from 'views/Admin/UsageReport/types';

// === Backend contract (mirrors AuditLogDto / AuditEventType) ===

export type AuditEventType =
  | 'ACCOUNT_SETTINGS_EVENT'
  | 'ASSET_EVENT'
  | 'CONFIGURATION_EVENT'
  | 'SERVICE_EVENT'
  | 'TRANSACTION_EVENT'
  | 'VIRTUAL_SERVICE_EVENT'
  | 'VIRTUAL_SERVICE_GROUP_EVENT'
  | 'VIRTUAL_SERVICE_TEMPLATE_EVENT';

export const AUDIT_EVENT_TYPES: AuditEventType[] = [
  'ACCOUNT_SETTINGS_EVENT',
  'ASSET_EVENT',
  'CONFIGURATION_EVENT',
  'SERVICE_EVENT',
  'TRANSACTION_EVENT',
  'VIRTUAL_SERVICE_EVENT',
  'VIRTUAL_SERVICE_GROUP_EVENT',
  'VIRTUAL_SERVICE_TEMPLATE_EVENT',
];

/** Raw entry as returned by the audit-log endpoints (snake_case JSON). */
export interface AuditLogDtoApi {
  id: string;
  account_id: number;
  workspace_id: number;
  user_id: number | null;
  /** Email of the acting user; "system" for system-initiated events, null on pre-migration rows. */
  user_email: string | null;
  event_type: AuditEventType;
  event_id: string;
  message: string;
  /** Unix epoch in SECONDS (BlazeSvOffsetDateTimeSerializer emits value.toEpochSecond()). */
  occurred_at: number;
}

/** Query params sent to the audit-log endpoints. Unset params are omitted by axios. */
export interface AuditLogQueryParams {
  start_time?: string;
  end_time?: string;
  event_type?: string;
  keyword?: string;
  skip?: number;
  limit?: number;
  sort?: string;
}

// === UI state ===

export interface AuditLogRow {
  id: string;
  occurredAt: string;
  eventType: AuditEventType;
  workspaceId: number;
  workspaceName: string;
  userId: number;
  userEmail: string | null;
  message: string;
}

export type AuditLogSortField = 'occurredAt' | 'eventType';

export interface AuditLogSort {
  field: AuditLogSortField;
  direction: 'ASC' | 'DESC';
}

export interface AuditLogFilters {
  period: PeriodSelection;
  /** null = all event types */
  eventType: AuditEventType | null;
  /** null = all workspaces (account endpoint); a number = single-workspace endpoint */
  workspaceId: number | null;
  keyword: string;
}

export const DEFAULT_AUDIT_FILTERS: AuditLogFilters = {
  period: { kind: 'preset', value: 'LAST_MONTH' },
  eventType: null,
  workspaceId: null,
  keyword: '',
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
export type PageSize = typeof PAGE_SIZE_OPTIONS[number];

export const DEFAULT_PAGE_SIZE: PageSize = 50;
export const DEFAULT_SORT: AuditLogSort = { field: 'occurredAt', direction: 'DESC' };

/** Minimum keyword length before the search filter is applied (matches UsageReport). */
export const MIN_KEYWORD_LENGTH = 2;
